<!--  -->
<template>
    <div class='box' style="flex-wrap: wrap">
        <div v-for="(item,index) in arr"
            :key="index"
            class="classifyitem"
            :class="{selected:item.isSelected}"
            @click="selectClassify(index)"
        >
          <Tooltip v-if="item.name != '时政要闻' && item.name != '党章党规' && item.name != '系列讲话'" placement="top"  >
            {{item.name}}
            <div slot="content">
              <div @click.stop="del(item,index,$event)">点我删除</div>
            </div>
          </Tooltip>
            <img
            v-if="item.isSelected"
            class="xuanzhong-icon color"
            src="../../../assets/images/select.png"
            />
        </div>

      <Poptip width="150">
        <span>
          <div class="iconfont icon-shangchuan1 classifyitem" style="width:70px"></div>
        </span>
        <div slot="content">
          <Input type="text" size="small" style="width: 62%" placeholder="分类名" v-model="fenlei" />
          <Button size="small" style="margin-left: 5px" @click="add">确定</Button>
        </div>
      </Poptip>

    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    props:{
        arr:{
            type:Array,
            default:[]
        }
    },
    data() {
    //这里存放数据
        return {
          fenlei:''
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        selectClassify(selectindex){
          this.$emit('selectFenlei',selectindex)

            this.arr.forEach((item,index)=>{
                if(selectindex == index){
                    item.isSelected = true
                }else{
                    item.isSelected = false
                }
            })
        },
      add () {
        this.$emit('addFenlei',this.fenlei)
        this.fenlei = ''
      },
      del (obj, index, $event) {
        obj.index = index;
        this.$emit("delFenlei", obj);
      }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.classifyitem{
    padding:0 17px;
    border:1px solid #dedede;
    color:#999;
    height:26px;
    line-height: 26px;
    font-size: 14px;
    border-radius:4px;
    margin-right:20px;
    text-align: center;
    position:relative;
    cursor: pointer;
  margin-bottom: 10px;
}
.selected{
    border:1px solid #ff7b43;
    color:#ff7b43;
}
.xuanzhong-icon{
    position:absolute;
    top:-8px;
    right:-8px;
    height:16px;
    width:16px;
}
</style>
